import { useEffect, useState } from 'react';
import { useStore } from '../core/store';
import { LoadableStatus } from '../mobx-utils';
import DOMPurify from 'dompurify';
import { convert as removeHtml } from 'html-to-text';

export function useHotelPoi() {
  const [hotelPoi, setHotelPoi] = useState(null);

  const { booking } = {
    ...useStore().BookingStore,
  };

  useEffect(() => {
    async function fetchHotelInfo() {
      let hotel = null;

      const waitForGeoLocation = setInterval(async () => {
        if (booking?.status === LoadableStatus.done) {
          hotel = booking.data?.hotels?.[0];
          clearInterval(waitForGeoLocation);
        }

        if (hotel?.geoData) {
          setHotelPoi(generateHotelPoi(hotel));
        } else {
          return null;
        }
      }, 100);
    }
    fetchHotelInfo();
  }, []);

  return hotelPoi;
}

function generateHotelPoi(hotel) {
  return {
    id: hotel.name,
    de: {
      title: hotel.name,
      description: removeHtml(DOMPurify.sanitize(hotel.description)),
    },
    categories: [
      {
        name: 'lodging-holidayhome',
        color: '#881767',
        _id: '0',
      },
    ],
    images: [
      {
        url: hotel.images?.[0]?.url,
        source: 'Giata',
      },
    ],
    location: {
      type: 'Point',
      coordinates: [hotel.geoData.longitude, hotel.geoData.latitude],
    },
    provider: 'Bentour Reisen',
    rating: 10,
    copyright: {
      source: 'Bentour Reisen',
    },
    address: { city: hotel?.street },
    phone: hotel.phone,
    eMail: hotel.email,
  };
}
